"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { useLoggedIn } from "@/store/useAuthStore";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import usePost from "@/hooks/usePost";
import Modal from "react-modal";
import { useDictionary } from "@/components/DictProvider/DictProvider";
import CustomNavLink from "@/components/CustomLink/CustomNavLink";
import { LangSetter } from "./LangSwitch";

const Hamburger = () => {
  const searchParams = useSearchParams();
  const translate = useDictionary();
  const { auth } = useLoggedIn();
  const [toggle, setToggle] = useState(false);
  const [isOpenCont, setIsOpenCont] = useState(false);
  const [catList, setCatList] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [catName, setCatName] = useState("");
  const [category, setCategory] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const router = useRouter();
  const currentPath = router.pathname;
  const pathName = usePathname();

  const { PostMethod, loading } = usePost();

  const handleToggleButton = () => {
    setToggle((prev) => {
      // Reset subcategories when closing the menu
      if (prev === true) {
        setSubCategories([]);
      }
      return !prev;
    });
  };
  const toggleDropdownContact = () => {
    setIsOpenCont(!isOpenCont);
  };

  const handleNavigation = (e, path) => {
    setToggle(false);
    e.preventDefault();
    if (currentPath !== "/") {
      router.push(`/#${path}`); // Navigate to the home page with the hash
    } else {
      document.getElementById(`${path}`).scrollIntoView({ behavior: "smooth" });
    }
  };

  const homeHandler = (e) => {
    setToggle(false);
    e.preventDefault();
    if (currentPath !== "/") {
      router.push(`/`); // Navigate to the home page
    }
  };

  const getSubCategory = async (slug) => {
    try {
      let response = await PostMethod({
        method: "get",
        url: `catSubcat/subcategory/${slug}`,
        language: pathName?.split("/")[1],
      });

      if (response?.success === true) {
        if (response?.data?.length > 0) {
          setSubCategories(response?.data);
          setCatName(response?.categoryName);
          return;
        }

        router.push(`/category/${slug?.toLowerCase()}`);
        handleToggleButton();
      }
    } catch (error) {
      toast.error(error?.message || "Something Went Wrong");
      return;
    }
  };

  const subCategoryHandler = (slug) => {
    setCategory(slug);
    getSubCategory(slug);
  };

  useEffect(() => {
    let timeoutId;
    (async () => {
      setIsLoading(true);

      timeoutId = setTimeout(() => {
        setIsLoading(false);
        setCatList([]);
      }, 10000);

      try {
        const cat = await PostMethod({
          url: "catsubcat/category",
          method: "get",
          language: pathName?.split("/")[1],
        });

        if (cat?.success) {
          setCatList(cat.data || []);
        } else {
          setCatList([]);
        }
      } catch (error) {
        setCatList([]);
      } finally {
        clearTimeout(timeoutId);
        setIsLoading(false);
      }
    })();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };

    // eslint-disable-next-line
  }, [pathName?.split("/")[1]]);

  // Prevent scrolling when modal is open
  useEffect(() => {
    if (toggle) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [toggle]);

  return auth ? null : (
    <>
      <button>
        <Image
          onClick={handleToggleButton}
          src={"/images/drawer.svg"}
          width={28}
          height={28}
          alt="drawer"
          className="transition transform all duration-500 ease-in-out"
        />
      </button>

      {toggle && (
        <Modal
          isOpen={toggle}
          onRequestClose={() => setToggle((pre) => !pre)}
          className="bg-transparent h-fit w-full !outline-none !border-none"
          overlayClassName="fixed w-full h-full !outline-none !border-none inset-0 z-[1001] flex items-center justify-center bg-black/70"
        >
          <div
            className={`bg-[#FFFFFF] h-[100%] !outline-none !border-none w-full overflow-y-auto absolute top-0 right-0 pb-4 ${toggle == true ? "translate-x-0" : "translate-x-full"
              } `}
          >
            <div className="pt-4">
              <div
                style={{ direction: "ltr" }}
                className={`flex px-[16px] items-center justify-end`}
              >

                <div onClick={handleToggleButton}>
                  <Image
                    src={"/images/closeIcon.svg"}
                    width={24}
                    height={24}
                    alt="close menu"
                  />
                </div>
              </div>
              <div className="px-[16px]">
                <div onClick={() => {
                  setToggle(false);
                  if (pathName === "/en" || pathName === "/ar") {
                    return;
                  } else {
                    router.push(`/${pathName?.split("/")[1]}`);
                  }
                }} className="relative w-full flex items-center justify-center h-fit mb-3 overflow-hidden">
                  <Image
                    src="/images/brand5.png"
                    width={130}
                    height={60}
                    objectFit="contain"
                    alt="logo"
                    priority={true}
                    className="block lg:hidden"
                    unoptimized
                  />
                </div>
                <div className="w-full flex justify-between items-center">
                  <div className="w-fit flex justify-start items-center gap-2">
                    <div onClick={() => {
                      setToggle(false);
                      // router.push("/login")
                      window.location.href = pathName?.split("/")[1] == "ar" ? "/ar/login" : "/en/login"
                    }}><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#B67300" />
                        <path d="M16 8.6C16.9017 8.6 17.7665 8.95821 18.4042 9.59584C19.0418 10.2335 19.4 11.0983 19.4 12C19.4 12.9017 19.0418 13.7665 18.4042 14.4042C17.7665 15.0418 16.9017 15.4 16 15.4C15.0983 15.4 14.2335 15.0418 13.5958 14.4042C12.9582 13.7665 12.6 12.9017 12.6 12C12.6 11.0983 12.9582 10.2335 13.5958 9.59584C14.2335 8.95821 15.0983 8.6 16 8.6ZM16 18.6C18.1371 18.6 20.0414 19.034 21.3892 19.7079C22.7727 20.3997 23.4 21.2446 23.4 22V23.4H8.6V22C8.6 21.2446 9.22732 20.3997 10.6108 19.7079C11.9586 19.034 13.8629 18.6 16 18.6Z" stroke="#B67300" stroke-width="1.2" />
                      </svg>
                    </div>
                    <div onClick={() => {
                      setToggle(false);
                      router.push("/cart")
                    }}>
                      <svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="35" height="31" rx="3.5" stroke="#B67300" />
                        <path d="M8.44531 8H10.7828L11.6475 9.74454M14.47 15.439L13.2568 17.3903C12.7954 18.1324 13.3291 19.0927 14.203 19.0927H23.754M14.47 15.439H20.4938C21.0019 15.439 21.4698 15.1622 21.7144 14.7168L24.2187 10.1572C24.3206 9.97153 24.1863 9.74454 23.9746 9.74454H11.6475M14.47 15.439L11.6475 9.74454" stroke="#B57209" stroke-width="1.2" />
                        <ellipse cx="13.6514" cy="22.405" rx="1.59671" ry="1.59642" stroke="#B67300" stroke-width="1.2" />
                        <ellipse cx="22.1358" cy="22.405" rx="1.59671" ry="1.59642" stroke="#B67300" stroke-width="1.2" />
                      </svg>
                    </div>
                  </div>
                  <div>

                    {pathName?.split("/").includes("ar") ? <div className="cursor-pointer" onClick={() => LangSetter(auth, PostMethod, searchParams, pathName, router, "en")}>
                      <div className="text-base h-[34px] font-medium relative flex items-center border border-primary rounded-md">
                        <p className="inline-block px-4 text-primary">English</p>
                      </div>
                    </div> : <div className="cursor-pointer" onClick={() => LangSetter(auth, PostMethod, searchParams, pathName, router, "ar")}>
                      <div className="text-base h-[34px] font-medium relative flex items-center border border-primary rounded-md">
                        <p className="inline-block px-4 text-primary"> العربية </p>
                      </div>
                    </div>}
                  </div>
                </div>
              </div>
              <div className="w-full h-[2px] bg-primary my-4"></div>
              {subCategories?.length === 0 ? (
                <div className="px-[16px]">
                  <ul className="flex flex-col gap-[17px] text-[17px] leading-[22px] text-primary font-semibold">
                    <li className="flex justify-start items-center gap-1">
                      <i><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.4106 3.39369C12.2912 3.30057 12.1441 3.25 11.9926 3.25C11.8412 3.25 11.6941 3.30057 11.5747 3.39369L1.90234 10.9357L2.739 11.9938L3.92162 11.0716V19.4038C3.92233 19.7606 4.06438 20.1026 4.31669 20.3549C4.56899 20.6072 4.91099 20.7493 5.2678 20.75H18.7296C19.0864 20.7493 19.4284 20.6072 19.6807 20.3549C19.933 20.1026 20.0751 19.7606 20.0758 19.4038V11.0777L21.2584 11.9998L22.0951 10.9417L12.4106 3.39369ZM13.3449 19.4038H10.6525V14.0191H13.3449V19.4038ZM14.6911 19.4038V14.0191C14.6911 13.6621 14.5492 13.3197 14.2968 13.0672C14.0443 12.8147 13.7019 12.6729 13.3449 12.6729H10.6525C10.2955 12.6729 9.95309 12.8147 9.70063 13.0672C9.44817 13.3197 9.30634 13.6621 9.30634 14.0191V19.4038H5.2678V10.0223L11.9987 4.77891L18.7296 10.029V19.4038H14.6911Z" fill="#B57209" />
                      </svg>
                      </i>
                      <button onClick={homeHandler}>
                        {translate.headerText.home}{" "}
                      </button>
                    </li>
                    <div onClick={() => {
                      router.push("/brands")
                    }} className="flex justify-start items-center gap-1">
                      <i>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.5 3.69688C9.533 6.78188 14.536 0.123876 17.496 2.53988C19.199 3.92988 18.66 6.99988 16.449 8.99988" stroke="#B57209" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M18.6641 6.578C19.6471 6.757 19.8681 7.343 20.1611 8.97C20.4261 10.436 20.5001 12.195 20.5001 12.944C20.4701 13.2215 20.3516 13.482 20.1621 13.687C18.1051 15.722 14.0251 19.565 11.9661 21.474C11.1581 22.155 9.93807 22.17 9.08007 21.544C7.32407 20.053 5.63707 18.366 3.98307 16.843C3.31907 16.035 3.33507 14.887 4.05907 14.126C6.23707 11.991 10.1791 8.337 12.4051 6.319C12.6281 6.139 12.9011 6.025 13.1951 6C13.6931 6 14.5501 6.063 15.3851 6.109" stroke="#B57209" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M12.3607 11.0293C12.432 10.938 12.5786 10.9892 12.5775 11.1052L12.5573 13.1622C12.5567 13.2231 12.6014 13.275 12.6617 13.2835L14.6988 13.5695C14.8137 13.5857 14.8426 13.7383 14.7416 13.7952L12.95 14.8063C12.897 14.8362 12.8744 14.9008 12.8972 14.9573L13.6681 16.8646C13.7115 16.972 13.5938 17.0734 13.494 17.0144L11.7226 15.9684C11.6702 15.9374 11.6029 15.9502 11.5654 15.9982L10.2991 17.6194C10.2277 17.7107 10.0811 17.6595 10.0823 17.5435L10.1025 15.4865C10.1031 15.4256 10.0584 15.3737 9.99806 15.3652L7.96092 15.0792C7.8461 15.063 7.81721 14.9104 7.91818 14.8535L9.70972 13.8424C9.76277 13.8125 9.78538 13.7479 9.76255 13.6914L8.99171 11.7841C8.94827 11.6767 9.06597 11.5753 9.16581 11.6343L10.9371 12.6803C10.9896 12.7113 11.0569 12.6985 11.0944 12.6505L12.3607 11.0293Z" stroke="#B57209" />
                        </svg>
                      </i>
                      <button onClick={homeHandler}>
                        {translate.productListPage.brandLower}
                      </button>
                    </div>
                    {catList?.length > 0 && (
                      catList?.map((item) => (
                        <li key={item?._id}>
                          <label
                            onClick={() =>
                              subCategoryHandler(item?.categorySlug)
                            }
                            className="flex justify-between items-center"
                          >
                            <div className="flex justify-start items-center gap-1">
                              <i>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.25 10.5V14.25M14.25 14.25V18M14.25 14.25H18M14.25 14.25H10.5M17.25 8.25V7.1875C17.25 6.08293 16.3546 5.1875 15.25 5.1875H6.6875C5.58293 5.1875 4.6875 6.08293 4.6875 7.1875V16C4.6875 17.1046 5.58293 18 6.6875 18H8.25M8.25 18.25V10.25C8.25 9.14543 9.14543 8.25 10.25 8.25H18.25C19.3546 8.25 20.25 9.14543 20.25 10.25V18.25C20.25 19.3546 19.3546 20.25 18.25 20.25H10.25C9.14543 20.25 8.25 19.3546 8.25 18.25Z" stroke="#B57209" stroke-width="1.4" />
                                </svg>
                              </i>
                              <span>{item?.category}</span>
                            </div>
                            <i><svg
                              width="10"
                              height="16"
                              viewBox="0 0 10 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="rtl:rotate-180"
                            >
                              <path
                                d="M9.49902 8.43359L1.99902 15.9336L0.949024 14.8836L7.39902 8.43359L0.949024 1.98359L1.99902 0.933593L9.49902 8.43359Z"
                                fill="#AC7529"
                                fill-opacity="0.6"
                              />
                            </svg></i>

                          </label>
                        </li>
                      ))
                    )}
                    <li className="flex justify-start items-center gap-1">
                      <i>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.9529 8.86667C12.4683 8.86667 12.8862 8.4488 12.8862 7.93333C12.8862 7.41787 12.4683 7 11.9529 7C11.4374 7 11.0195 7.41787 11.0195 7.93333C11.0195 8.4488 11.4374 8.86667 11.9529 8.86667Z" fill="#B57209" />
                          <path d="M13.9987 15.3333H12.6654V10H10.6654C10.4886 10 10.319 10.0702 10.194 10.1953C10.0689 10.3203 9.9987 10.4899 9.9987 10.6667C9.9987 10.8435 10.0689 11.013 10.194 11.1381C10.319 11.2631 10.4886 11.3333 10.6654 11.3333H11.332V15.3333H9.9987C9.82189 15.3333 9.65232 15.4036 9.52729 15.5286C9.40227 15.6536 9.33203 15.8232 9.33203 16C9.33203 16.1768 9.40227 16.3464 9.52729 16.4714C9.65232 16.5964 9.82189 16.6667 9.9987 16.6667H13.9987C14.1755 16.6667 14.3451 16.5964 14.4701 16.4714C14.5951 16.3464 14.6654 16.1768 14.6654 16C14.6654 15.8232 14.5951 15.6536 14.4701 15.5286C14.3451 15.4036 14.1755 15.3333 13.9987 15.3333Z" fill="#B57209" />
                          <path d="M12 4C10.4178 4 8.87104 4.46919 7.55544 5.34824C6.23985 6.22729 5.21447 7.47672 4.60897 8.93853C4.00347 10.4003 3.84504 12.0089 4.15372 13.5607C4.4624 15.1126 5.22433 16.538 6.34315 17.6569C7.46197 18.7757 8.88743 19.5376 10.4393 19.8463C11.9911 20.155 13.5997 19.9965 15.0615 19.391C16.5233 18.7855 17.7727 17.7602 18.6518 16.4446C19.5308 15.129 20 13.5822 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 18.6667C10.6815 18.6667 9.39253 18.2757 8.2962 17.5431C7.19987 16.8106 6.34539 15.7694 5.84081 14.5512C5.33622 13.333 5.2042 11.9926 5.46144 10.6994C5.71867 9.40619 6.35361 8.2183 7.28596 7.28595C8.21831 6.3536 9.4062 5.71867 10.6994 5.46143C11.9926 5.2042 13.3331 5.33622 14.5512 5.8408C15.7694 6.34539 16.8106 7.19987 17.5431 8.2962C18.2757 9.39253 18.6667 10.6815 18.6667 12C18.6667 12.8755 18.4942 13.7424 18.1592 14.5512C17.8242 15.3601 17.3331 16.095 16.714 16.714C16.095 17.3331 15.3601 17.8242 14.5512 18.1592C13.7424 18.4942 12.8755 18.6667 12 18.6667Z" fill="#B57209" />
                        </svg>

                      </i>
                      <a
                        href="#about"
                        onClick={(e) => handleNavigation(e, "about")}
                      >
                        {translate.addressPage.aboutUs}
                      </a>
                    </li>
                    <li>

                      <label
                        onClick={toggleDropdownContact}
                        className="flex justify-between items-center"
                      >
                        <div className="flex justify-start items-center gap-1"> <i>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.1676 11.0049C16.1676 10.7165 16.1676 10.5723 16.211 10.4439C16.3369 10.0705 16.6694 9.92625 17.0029 9.77454C17.3763 9.60367 17.563 9.51864 17.7489 9.50364C17.9589 9.48697 18.1698 9.53198 18.3499 9.63284C18.5883 9.76621 18.755 10.0213 18.925 10.228C19.7111 11.1832 20.1045 11.6609 20.2479 12.1868C20.3646 12.6119 20.3646 13.0571 20.2479 13.4813C20.0387 14.2499 19.376 14.8934 18.885 15.4902C18.6341 15.7944 18.5083 15.947 18.3499 16.0362C18.1667 16.1377 17.9576 16.1827 17.7489 16.1654C17.563 16.1504 17.3763 16.0653 17.002 15.8945C16.6686 15.7428 16.3369 15.5986 16.211 15.2251C16.1676 15.0968 16.1676 14.9526 16.1676 14.6641V11.0049ZM7.83214 11.0049C7.83214 10.6414 7.82214 10.3155 7.52873 10.0605C7.42204 9.96793 7.28033 9.90374 6.99776 9.77454C6.6235 9.6045 6.43678 9.51864 6.2509 9.50364C5.69492 9.45863 5.39568 9.83873 5.07559 10.2288C4.28872 11.1832 3.89529 11.6609 3.75108 12.1877C3.63506 12.6114 3.63506 13.0585 3.75108 13.4822C3.96114 14.2499 4.62464 14.8942 5.11477 15.4902C5.42402 15.8653 5.71993 16.2079 6.2509 16.1654C6.43678 16.1504 6.6235 16.0653 6.99776 15.8945C7.28117 15.7661 7.42204 15.7011 7.52873 15.6086C7.82214 15.3535 7.83214 15.0276 7.83214 14.665V11.0049Z" stroke="#B57209" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6.16406 9.5013C6.16406 6.73892 8.77641 4.5 11.9989 4.5C15.2214 4.5 17.8338 6.73892 17.8338 9.5013M17.8338 16.1697V16.8365C17.8338 18.3094 16.3417 19.5039 14.4996 19.5039H12.8325" stroke="#B57209" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>

                        </i>
                          <span>{translate.footerPage.contactus}</span></div>

                        <svg
                          className={`transition-transform duration-300 ${isOpenCont == true ? "" : "rotate-180"
                            }`}
                          width="15"
                          height="9"
                          viewBox="0 0 16 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.99994 0.5L15.4999 8L14.4499 9.05L7.99994 2.6L1.54994 9.05L0.499939 8L7.99994 0.5Z"
                            fill="#AC7529"
                          />
                        </svg>{" "}
                      </label>
                      {isOpenCont && (
                        <div className=" flex flex-col  mt-2 ">
                          <a
                            href="tel:+96594979199"
                            className="flex gap-[8px] items-center h-[34px] text-[16px] leading-[21px] text-[#00000099] font-medium"
                          >
                            {" "}
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.83589 10.1386C6.01325 12.3156 8.66504 13.9957 10.827 13.9957C11.799 13.9957 12.6501 13.6566 13.3357 12.9032C13.7349 12.4586 13.9837 11.9389 13.9837 11.4269C13.9837 11.0501 13.8404 10.6885 13.4791 10.4324L11.1735 8.78986C10.8196 8.54879 10.5258 8.42825 10.2545 8.42825C9.908 8.42825 9.6065 8.62432 9.26 8.96311L8.72514 9.49057C8.68773 9.52849 8.6432 9.55865 8.59411 9.57934C8.54503 9.60002 8.49234 9.61082 8.43907 9.61111C8.31854 9.61111 8.21279 9.56611 8.13018 9.52818C7.67054 9.27972 6.87211 8.59411 6.12607 7.85579C5.38775 7.11747 4.70214 6.31904 4.46107 5.852C4.40915 5.75983 4.38077 5.65627 4.37846 5.5505C4.37846 5.45279 4.40836 5.35443 4.49129 5.27182L5.01843 4.72218C5.35786 4.37536 5.55361 4.07386 5.55361 3.72736C5.55361 3.4564 5.43307 3.16261 5.18461 2.80839L3.56461 0.525609C3.30104 0.164002 2.93204 0.00585938 2.52511 0.00585938C2.02786 0.00585938 1.50811 0.231824 1.07129 0.661574C0.340358 1.36229 0.0163574 2.22822 0.0163574 3.18479C0.0163574 5.34704 1.66625 7.96893 3.83589 10.1386Z"
                                fill="black"
                                fill-opacity="0.6"
                              />
                            </svg>{" "}
                            <span>+965 9497 9199</span>
                          </a>
                          <a
                            href="mailto:info@camouflage.com.kw"
                            className="flex gap-[8px] items-center h-[34px] text-[16px] leading-[21px] text-[#00000099] font-medium"
                          >
                            {" "}
                            <svg
                              width="16"
                              height="12"
                              viewBox="0 0 16 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.99988 12.002C1.58738 12.002 1.23438 11.8552 0.940878 11.5617C0.647378 11.2682 0.500378 10.915 0.499878 10.502V1.50195C0.499878 1.08945 0.646878 0.736453 0.940878 0.442953C1.23488 0.149453 1.58788 0.00245312 1.99988 0.00195312H13.9999C14.4124 0.00195312 14.7656 0.148953 15.0596 0.442953C15.3536 0.736953 15.5004 1.08995 15.4999 1.50195V10.502C15.4999 10.9145 15.3531 11.2677 15.0596 11.5617C14.7661 11.8557 14.4129 12.0025 13.9999 12.002H1.99988ZM7.99988 6.75195L13.9999 3.00195V1.50195L7.99988 5.25195L1.99988 1.50195V3.00195L7.99988 6.75195Z"
                                fill="black"
                                fill-opacity="0.6"
                              />
                            </svg>{" "}
                            <span>info@camouflage.com.kw</span>
                          </a>
                        </div>
                      )}
                    </li>
                  </ul>
                </div>
              ) : (
                <div className="px-[16px]">
                  {subCategories?.length > 0 && (
                    <div
                      onClick={() => setSubCategories([])}
                      className="flex justify-start items-center my-4 rtl:flex-row-reverse"
                    >
                      <p className="mr-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z"
                            fill="#AC7529"
                          />
                          <path
                            d="M5.56038 12L11.7809 18.219C11.9217 18.3598 12.0008 18.5508 12.0008 18.75C12.0008 18.9491 11.9217 19.1401 11.7809 19.281C11.64 19.4218 11.449 19.5009 11.2499 19.5009C11.0507 19.5009 10.8597 19.4218 10.7189 19.281L3.96888 12.531C3.89903 12.4613 3.84362 12.3785 3.80581 12.2874C3.768 12.1963 3.74854 12.0986 3.74854 12C3.74854 11.9013 3.768 11.8036 3.80581 11.7125C3.84362 11.6214 3.89903 11.5386 3.96888 11.469L10.7189 4.71897C10.8597 4.57814 11.0507 4.49902 11.2499 4.49902C11.449 4.49902 11.64 4.57814 11.7809 4.71897C11.9217 4.8598 12.0008 5.05081 12.0008 5.24997C12.0008 5.44913 11.9217 5.64014 11.7809 5.78097L5.56038 12Z"
                            fill="#AC7529"
                          />
                        </svg>
                      </p>
                      <p className="text-lg font-bold text-primary">
                        {catName}
                      </p>
                    </div>
                  )}
                  <div className="w-full h-full">
                    <ul
                      className="flex flex-col gap-[17px] text-[17px] leading-[22px] text-primary font-semibold"
                    >
                      {subCategories?.map(item => (
                        <li
                          key={item?.subCategory}
                          onClick={() => {
                            handleToggleButton();
                          }}
                          className="flex justify-start items-center gap-1"
                        >
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 16.875C4.6575 16.875 1.125 13.3425 1.125 9C1.125 4.6575 4.6575 1.125 9 1.125C13.3425 1.125 16.875 4.6575 16.875 9C16.875 13.3425 13.3425 16.875 9 16.875ZM9 2.25C5.27625 2.25 2.25 5.27625 2.25 9C2.25 12.7238 5.27625 15.75 9 15.75C12.7238 15.75 15.75 12.7238 15.75 9C15.75 5.27625 12.7238 2.25 9 2.25Z" fill="#B57209" />
                            <path d="M9 14.6953C12.1454 14.6953 14.6953 12.1454 14.6953 9C14.6953 5.85457 12.1454 3.30469 9 3.30469C5.85457 3.30469 3.30469 5.85457 3.30469 9C3.30469 12.1454 5.85457 14.6953 9 14.6953Z" fill="#B57209" />
                          </svg>

                          <CustomNavLink
                            href={`/category/${category?.toLowerCase()}?category=${item?.subCategory
                              ?.replace(" ", "+")
                              ?.replace("&", "%26")}`}
                          >
                            {item?.subCategory}
                          </CustomNavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {isLoading && (
                <div className="absolute w-full h-full inset-0 flex justify-center items-center bg-white/50">
                  <span className="loader"></span>
                </div>
              )}
            </div>
          </div >
        </Modal >
      )}
    </>
  );
};

export default Hamburger;
